<div class="modal-header">
  <h4 class="modal-title">Fare Details</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>
<!-- Modal Body -->
<div class="modal-body">
  <!-- Full Load end here -->
  <div class="card border rounded-3">
    <div class="card-body p-4">
      <!-- Summary -->
      <div class="d-flex justify-content-between fw-semibold mb-2">
        <span>Item Total</span>
        <span>₹{{ orderDetails?.totals?.productAmount }}</span>
      </div>
      <div
        *ngFor="let item of orderDetails?.otherCharges; let i = index"
        class="d-flex justify-content-between small mb-2"
      >
        <span [ngClass]="{ 'success-text': item?.isDiscount }">{{
          item?.label
        }}</span>
        <span [ngClass]="{ 'success-text': item?.isDiscount }"
          >₹{{ item?.charge }}</span
        >
      </div>
      <hr />
      <div class="d-flex justify-content-between fw-bold">
        <span>Total Order Fare</span>
        <span>₹{{ orderDetails?.totals?.amount }}</span>
      </div>
    </div>
  </div>
  <!-- Full Load end here -->
  <!-- Part Load start here -->
  <!-- <div class="card border rounded-3">
    <div class="card-body p-4"> -->
  <!-- Company 1 -->
  <ng-container *ngIf="orderDetails?.type !== 'full-load'">
    <ng-container *ngFor="let item of orderDetails?.subOrders; let i = index">
      <h6 class="fw-bold mb-3">{{ item?.pickup?.address?.companyName }}</h6>
      <ng-container *ngFor="let item2 of item?.pickup?.items; let i2 = index">
        <div class="d-flex justify-content-between small mb-1">
          <span
            >{{ item2.product.name }}
            <span *ngIf="item2.product.subItems">
              {{ item2.product.subItems.name }}
            </span>
            | Qty: {{ item2.planned.qty }}</span
          >
          <span
            >₹{{
              (getChargeWeight(item2, item.productDifferences) *
                (orderDetails?.type === 'part-load-door'
                  ? item2?.product?.subItems?.price ? item2?.product?.subItems?.price :  item2.product?.price
                  : item2?.product?.subItems?.bstOfficePrice ? item2?.product?.subItems?.bstOfficePrice :  item2.product?.bstOfficePrice  )) /
                1000
            }}</span
          >
        </div>
        <div class="d-flex justify-content-between small mb-1">
          <span> {{ getChargeWeight(item2, item.productDifferences) }}KG</span>
        </div>
        <hr />
      </ng-container>
    </ng-container>
  </ng-container>
  <!-- Company 2 -->
  <!-- <h6 class="fw-bold mb-3">Axoli Tiles Pvt. Ltd</h6>
      <div class="d-flex justify-content-between small mb-1">
        <span>TILES 600 × 1200 Qty: 20</span>
        <span>₹2000</span>
      </div>
      <div class="d-flex justify-content-between small mb-1">
        <span>1000KG × R2</span>
      </div>
      <div class="d-flex justify-content-between small mb-1">
        <span>TILES 800×800 Qty: 10</span>
        <span>₹500</span>
      </div>
      <div class="d-flex justify-content-between small mb-3">
        <span>500KG × R1</span>
      </div>
      <hr /> -->
  <!-- Summary -->
  <!-- <div class="d-flex justify-content-between fw-semibold mb-2">
        <span>Item Total</span>
        <span>₹11500</span>
      </div>
      <div class="d-flex justify-content-between small mb-2">
        <span>LR Charge</span>
        <span>₹100</span>
      </div>
      <div class="d-flex justify-content-between small mb-2">
        <span>Tempo fee (2 Pickup)</span>
        <span>₹2000</span>
      </div>
      <div class="d-flex justify-content-between small text-success mb-2">
        <span>Discount (2000kg plus order discount)</span>
        <span>-₹2000</span>
      </div>
      <hr />
      <div class="d-flex justify-content-between fw-bold">
        <span>Total Order Fare</span>
        <span>₹11600</span>
      </div>
    </div>
  </div> -->
  <!-- Part Load end here -->
</div>
